import React from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";

import { DiscoverRoutes } from "./Constants/routes";

const Discover = () => {
  const match = useRouteMatch();
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {DiscoverRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/discover" />
      </Switch>
    </>
  );
};

export default Discover;
